import React from 'react';
import productPng from '../../assets/images/product5.png';

const ViewImageModal = () => {
  return (
    <>
     <div className="modal fade" id="viewImageModal" tabindex="-1" role="dialog" aria-labelledby="viewImageModalLabel">
                <div className="modal-dialog modal-dialog-centered modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="product-image">
                                        <img src={productPng}></img>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="download-btns mt-3">
                                        <button type="button" className="btn cancel-btn" data-dismiss="modal">Cancel</button>
                                        <button type="button" className="btn download-confirm-btn" data-dismiss="modal">Download <i className="fas fa-download ml-1"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
    </>
  )
}

export default ViewImageModal